module.exports = __webpack_public_path__ + "img/1ef5e598cf8854d1af8a86c1467380ba.png";